import PropTypes from 'prop-types';
import Carousel from '../../Carousel';
import animationData from '../../../config/animationData';

function AnimationCarousel({ category }) {

    const categoryAnimationData = animationData[category];

    const carouselItems = categoryAnimationData.map((item) => ({
        id: item.id,
        content: (
            <a className='animation-carousel' href={item.facebook}>
                <img src={item.logo} alt={item.name} style={{'height': '100%'}}/>
                <h4 style={{'textAlign': 'center', 'marginTop': '10px'}}>{item.name}</h4>
            </a>
            
        ),
    }));

    return <Carousel items={carouselItems} loop={categoryAnimationData.length > 3} />;
}

AnimationCarousel.propTypes = {
    category: PropTypes.string.isRequired,
};

  

export default AnimationCarousel;